import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';

import api from '@/services/api';

const ModalDeleteDictionary = ({ reloadDictionary, showModalDeleteDictionary, setShowModalDeleteDictionary }) => {
	const { dict } = useSelector((state) => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);

	const handleClose = useCallback(() => {
		setRequestIsPending(false);
		setShowModalDeleteDictionary(false);
	}, []);

	const removeConfirmed = async () => {
		setRequestIsPending(true);
		try {
			await api.delete(`/dict-entries`);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			handleClose();
			reloadDictionary();
		}
		
	};

	return (
		<ModalWrapperChildren 
			onClose={ handleClose }
			setModalVisible={ setShowModalDeleteDictionary }
			modalVisible={ showModalDeleteDictionary }
			onConfirm={ removeConfirmed }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.dictionary.modalDelete.confirm }
			requestIsPending={ requestIsPending }
			title={ dict.dictionary.modalDelete.title }
			description={ <span>{dict.dictionary.modalDelete.description}<br/> {dict.dictionary.modalDelete.description2} </span> }
		>		
			
		</ModalWrapperChildren>
	);
};

export default React.memo(ModalDeleteDictionary);